<template>
  <div class="outsider_body">
    <!-- <header></header> -->
    <div class="header">
      <div class="head_warp">
        <div class="head_title">{{$store.state.eduWebConfig.eduWebConfigInfo.webName}}</div>
      </div>
    </div>
    <!-- conotent -->
    <div class="content" v-loading="loading" element-loading-text="拼命加载中">
      <div class="warp" style="height: calc(100vh - 180px)">
        <div class="index">
          <div class="entrance-bottom">
            <div class="entrance-bottom-frame clearfix"></div>
          </div>
        </div>
      </div>
    </div>

    <!--footer-->
    <div class="main-footer">
      <p>
        <a target="_bank" href="https://beian.miit.gov.cn"
          >蜀ICP备20012822号-4</a
        >
      </p>
      <p>
        <a href="http://www.bluerhyme.net/" target="_bank"
          ><img class="bottom_logo" src="/static/images/logo_icon.png" />{{
            $store.state.eduWebConfig.eduWebConfigInfo.scaleAlias
              ? "四川蓝韵心理咨询服务有限公司"
              : "四川蓝韵心理咨询服务有限公司"
          }}</a
        >
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      last: false,
      curQuestionNum: 0,
      mmpt_record_id: null,
      oldAnswerData: null, // 断点答案数据
      answerData: [],
      loading: false,
      AnswerRecords: [],
      startTime: new Date(), // 开始答题时间
    };
  },
  mounted() {
    this.getBreakAnserList(); // 断点保存问题列表
  },
  methods: {
    init() {
      let self = this;
      var dact = document.querySelector(".entrance-bottom-frame-line");
      var active = "active";
      var none = "none";
      var btns = document.querySelectorAll(
        ".entrance-bottom-frame-line-button"
      );
      this.addClass(dact, active);
      var timu_id = 0;
      if (self.AnswerRecords.length == self.curQuestionNum) {
        self.last == true;
        $(".submit").css("display", "inline-block");
      }
      for (var i = 0; i < btns.length; i++) {
        // 选择
        btns[i].onclick = function () {
          if (self.AnswerRecords.length >= self.curQuestionNum - 1) {
            self.last = true;
          }
          $(this).siblings().removeClass("active_option");
          $(this).addClass("active_option");
          var tempObj = {};
          tempObj.question_id =
            this.getAttribute("question_id") * 1; /* 问题ID */
          tempObj.option_id = this.getAttribute("option_id") * 1; // 选项id
          if (self.AnswerRecords.length >= self.curQuestionNum) {
            for (let index = 0; index < self.AnswerRecords.length; index++) {
              const element = self.AnswerRecords[index];
              if (element.question_id == tempObj.question_id) {
                self.AnswerRecords[index].option_id = tempObj.option_id;
                break;
              }
            }
          } else {
            self.AnswerRecords.push(tempObj);
          }
          self.customrules(); //自定义规则
          self.breakSaveScale(); // 断点保存
          if (!self.last) {
            var frame_left = self.getStyle(
              document.querySelector(".entrance-bottom-frame"),
              "marginLeft"
            );
            timu_id++;
            document.querySelector(".entrance-bottom-frame").style.marginLeft =
              // parseInt(frame_left) - 1050 + "px";
              -550 + -timu_id * 1050 + "px";
            self.addClass(
              document.querySelectorAll(".entrance-bottom-frame-line")[timu_id],
              active
            );
            self.removeClass(
              document.querySelectorAll(".entrance-bottom-frame-line")[
                timu_id - 1
              ],
              active
            );
            self.addClass(
              document.querySelectorAll(".entrance-bottom-frame-beijing")[
                timu_id - 1
              ],
              none
            );
          } else {
            self.$message.info("最后一题啦!");
            $(".submit").css("display", "inline-block");
          }
        };
      }
      // 提交
      $(".submit").click(function () {
        $(this).hide();
        self.saveScale();
      });
      // 返回
      $(".back").click(function () {
        self.$router.go(-1); //返回上一层
      });
      var dac = $(".entrance-bottom-frame-line");
      for (let i = 0; i < dac.length; i++) {
        var options = dac[i].getElementsByClassName(
          "entrance-bottom-frame-line-button"
        );
        for (let j = 0; j < options.length; j++) {
          if (options.length > 6) {
            self.addClass(options[j], "long");
          } else {
            self.addClass(options[j], "short");
          }
        }
      }
    },
    //线程睡眠
    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    //自定义规则
    customrules() {
      //注意这个自定义规则如果 在量表被删除之后,需要重新前端写一次,找到对应的问题id,直接修改数据库,重传会导致选项ID失效
      let info = JSON.parse(window.sessionStorage.getItem("info"));
      if (info && info.customrule && info.customrule.length > 0) {
        eval(info.customrule);
      }
    },
    // 获取问题列表
    getAnswerList() {
      let self = this;
      this.loading = true;
      let info = JSON.parse(window.sessionStorage.getItem("info"));
      LYCom.AsynCallBiz(
        function (e) {
          if (e.rtnObj) {
            // 获取量表试题列表

            self.answerData = e.rtnObj;
            self.TiMu();
            self.loading = false;
          }
        },
        "MMPTBiz.GetQuestionsByScaleIdNoToken2",
        3, //personnelType  1：学生 2：教师 3：校外人员
        parseInt(this.$route.query.rel_id),
        info.scale_id,
        this.mmpt_record_id
      );
    },
    // 获取断点保存答案列表
    getBreakAnserList() {
      let self = this;
      let info = JSON.parse(window.sessionStorage.getItem("info"));
      LYCom.AsynCallBiz(
        function (e) {
          if (e.rtnObj) {
            self.oldAnswerData = e.rtnObj;
            self.mmpt_record_id = e.rtnObj.mmpt_record_id;
            self.AnswerRecords = e.rtnObj.AnswerList;
          }
          self.getAnswerList(); //  获取问题列表
        },
        "MMPTBiz.GetMmptRecordTmpNoToken",
        info.taskId,
        info.scale_id,
        info.register_id,
        3 //personnelType  1：学生 2：教师 3：校外人员
      );
    },
    TiMu() {
      let answerLen = this.answerData.length;
      let newArr = [],
        oldLen = 0;
      if (this.oldAnswerData && this.oldAnswerData.AnswerList) {
        oldLen = this.oldAnswerData.AnswerList.length;
        this.last = this.answerData.length == oldLen ? true : false;
        if (oldLen == this.answerData.length) {
          this.last = true;
        }
        for (
          let i = this.last ? oldLen - 1 : oldLen;
          i < this.answerData.length;
          i++
        ) {
          newArr.push(this.answerData[i]);
        }
      } else {
        newArr = this.answerData;
      }

      for (var i in newArr) {
        var div = document.createElement("div");
        div.className = "entrance-bottom-frame-line";
        document.querySelector(".entrance-bottom-frame").appendChild(div);

        var beijing = document.createElement("div");
        beijing.className = "entrance-bottom-frame-beijing";
        document
          .querySelectorAll(".entrance-bottom-frame-line")
          [i].appendChild(beijing);

        var div1 = document.createElement("div");
        div1.className = "entrance-bottom-frame-line-id";
        this.curQuestionNum = this.last ? oldLen + i * 1 : oldLen + i * 1 + 1;
        div1.innerHTML = this.curQuestionNum;
        document
          .querySelectorAll(".entrance-bottom-frame-line")
          [i].appendChild(div1);
        var div2 = document.createElement("div");
        var btns = document.createElement("div");
        var back = document.createElement("div");
        var submit = document.createElement("div");
        div2.className = "entrance-bottom-frame-line-title";
        btns.className = "btns";
        back.className = "back";
        submit.className = "submit";
        // 标题
        let info = JSON.parse(window.sessionStorage.getItem("info"));
        if (info.question_type == 1) {
          var img = document.createElement("img");
          img.className = "entrance-bottom-frame-line-title-img";
          img.src = newArr[i].description;
          div2.appendChild(img);
        } else {
          div2.innerHTML = newArr[i].description;
        }
        back.innerHTML = "返 回";
        submit.innerHTML = "提 交";
        btns.appendChild(back);
        btns.appendChild(submit);
        document
          .querySelectorAll(".entrance-bottom-frame-line")
          [i].appendChild(btns);
        document
          .querySelectorAll(".entrance-bottom-frame-line")
          [i].appendChild(div2);

        for (var j in newArr[i].options) {
          var div3 = document.createElement("div");
          div3.className = "entrance-bottom-frame-line-button";
          div3.setAttribute("question_id", newArr[i].question_id);
          div3.setAttribute("option_id", newArr[i].options[j].option_id);

          if (
            newArr[i].checkoption_id &&
            newArr[i].checkoption_id == newArr[i].options[j].option_id
          ) {
            div3.className = "entrance-bottom-frame-line-button active_option";
          } else {
            div3.className = "entrance-bottom-frame-line-button";
          }
          var div3_id = document.createElement("div");
          div3_id.className = "entrance-bottom-frame-line-button-id";
          if (j == 0) {
            div3_id.innerHTML = "A";
          } else if (j == 1) {
            div3_id.innerHTML = "B";
          } else if (j == 2) {
            div3_id.innerHTML = "C";
          } else if (j == 3) {
            div3_id.innerHTML = "D";
          } else if (j == 4) {
            div3_id.innerHTML = "E";
          } else if (j == 5) {
            div3_id.innerHTML = "F";
          } else if (j == 6) {
            div3_id.innerHTML = "G";
          } else {
            div3_id.innerHTML = "I";
          }
          var div4 = document.createElement("div");
          div4.className = "entrance-bottom-frame-line-button-frame";
          // 选项
          let info = JSON.parse(window.sessionStorage.getItem("info"));
          if (info.question_type == 1) {
            var img = document.createElement("img");
            img.className = "entrance-bottom-frame-line-title-option-img";
            img.src = newArr[i].options[j].description;
            div4.appendChild(img);
          } else {
            div4.innerHTML = newArr[i].options[j].description;
          }
          div3.appendChild(div3_id);
          div3.appendChild(div4);
          document
            .querySelectorAll(".entrance-bottom-frame-line")
            [i].appendChild(div3);
        }
      }
      this.init();
    },
    addClass(obj, cls) {
      var obj_class = obj.className, //获取 class 内容.
        blank = obj_class != "" ? " " : ""; //判断获取到的 class 是否为空, 如果不为空在前面加个'空格'.
      let added = obj_class + blank + cls; //组合原来的 class 和需要添加的 class.
      obj.className = added; //替换原来的 class.
    },
    removeClass(obj, cls) {
      var obj_class = " " + obj.className + " ",
        removed; //获取 class 内容, 并在首尾各加一个空格. ex) 'abc    bcd' -> ' abc    bcd '
      (obj_class = obj_class.replace(/(\s+)/gi, " ")), //将多余的空字符替换成一个空格. ex) ' abc    bcd ' -> ' abc bcd '
        (removed = obj_class.replace(" " + cls + " ", " ")); //在原来的 class 替换掉首尾加了空格的 class. ex) ' abc bcd ' -> 'bcd '
      removed = removed.replace(/(^\s+)|(\s+$)/g, ""); //去掉首尾空格. ex) 'bcd ' -> 'bcd'
      obj.className = removed; //替换原来的 class.
    },
    hasClass(obj, cls) {
      var obj_class = obj.className, //获取 class 内容.
        obj_class_lst = obj_class.split(/\s+/); //通过split空字符将cls转换成数组.
      x = 0;
      for (x in obj_class_lst) {
        if (obj_class_lst[x] == cls) {
          //循环数组, 判断是否包含cls
          return true;
        }
      }
      return false;
    },
    getStyle(obj, attr) {
      if (obj.currentStyle) {
        return obj.currentStyle[attr];
      } else {
        return document.defaultView.getComputedStyle(obj, null)[attr];
      }
    },
    /* 保存按钮 */
    saveScale() {
      let self = this;
      let info = JSON.parse(window.sessionStorage.getItem("info"));
      let taskInfo = JSON.parse(window.sessionStorage.getItem("taskInfo"));
      let ts = new Date() - this.startTime;
      var obj = {
        task_id: info.taskId,
        scale_id: info.scale_id /* 量表ID */,
        AnswerRecords: self.AnswerRecords, //问题和选项
        mmpt_duration: ts / 1000, // 单位：秒
        TmpRecordId: this.mmpt_record_id,
      };
      //学生/校外人员关系id
      if (info.task_out_rel_id) {
        obj.task_out_rel_id = info.task_out_rel_id;
      } else {
        obj.task_stu_rel_id = info.task_stu_rel_id;
      }
      if (self.oldAnswerData) {
        obj.mmpt_duration += self.oldAnswerData.answer_duration; // 合并时长
      }
      /* 去除答案里面重复的选项 */
      if (obj.AnswerRecords && obj.AnswerRecords.length > 0) {
        for (let i = 0; i < obj.AnswerRecords.length; i++) {
          for (let j = i + 1; j < obj.AnswerRecords.length; j++) {
            if (
              obj.AnswerRecords[i].question_id ===
              obj.AnswerRecords[j].question_id
            ) {
              obj.AnswerRecords.splice(j, 1);
              j = j - 1;
            }
          }
        }
      }
      /* 提交答案数据 */
      let success = LYCom.CallBiz("MMPTBiz", "InsertMMPTRecordNoToken", obj);
      this.dialogloading = false;
      this.dialogVisible = false;
      if (success) {
        self.$message.success("提交成功！");
        self.$router.go(-1); //返回上一层
      } else {
        self.$message.error("提交失败！");
      }
    },
    /* 断点保存 */
    breakSaveScale() {
      let self = this;
      let info = JSON.parse(window.sessionStorage.getItem("info"));
      let ts = new Date() - this.startTime;
      var obj = {
        task_id: info.taskId,
        register_id: info.register_id,
        scale_id: info.scale_id, //  量表id
        AnswerList: self.AnswerRecords, //问题和选项
        answer_duration: ts / 1000,
      };
      if (self.oldAnswerData) {
        obj.answer_duration += self.oldAnswerData.answer_duration; // 合并时长
      }
      obj.mmpt_record_id = self.mmpt_record_id;
      console.log(obj.AnswerList);
      /* 提交答案数据 */
      let success = LYCom.CallBiz("MMPTBiz", "SetMmptRecordTmpNoToken", obj);
      if (success.data) {
        this.mmpt_record_id = success.data;
      }
    },
  },
};
</script>

<style scoped>
.header {
  height: 70px;
  box-shadow: 0px 5px 15px #b3c6fc;
  color: white;
  background-image: url(/static/images/header_bg.jpg);
  z-index: 99;
  position: relative;
}

.head_warp {
  display: flex;
  flex-direction: column;
  align-items: left;
  padding: 15px;
}

.head_title {
  font-size: 24px;
}

.content .warp {
  padding: 20px 20px 20px 100px;
}

.back-head {
  padding-top: 60px;
  line-height: 100%;
}

.back-head h3 {
  font-size: 20px;
  font-weight: 400;
}

.back-head p {
  margin: 15px 0 60px;
  font-size: 16px;
  color: #333;
}

/deep/ .el-radio__label {
  font-size: 20px;
  color: #000;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #091d7c;
}

.next {
  width: 780px;
  text-align: center;
}

.next_btn {
  padding: 12px 50px;
}

.area_list {
  display: flex;
  width: 675px;
}

.class_warp {
  width: 675px;
  display: flex;
}

.radio_warp {
  margin: 20px 0;
}

.area_list .el-select,
.class_warp .el-select {
  flex: 1;
}

.el-form-item {
  margin-bottom: 30px;
}

.rest_title {
  font-size: 20px;
  padding: 10px;
  height: 40px;
  line-height: 40px;
  width: 780px;
  margin: 20px 0;
}

.footer_line {
  height: 10px;
  background: linear-gradient(left, #000147, #1cb4df);
}

.main-footer {
  height: 30px;
  text-align: center;
  margin-top: 10px;
}

.main-footer a {
  font-size: 13px;
  color: #999999;
  text-decoration: none;
}
</style>

<style>
.outsider_body {
  background-color: #f9f8fd;
  height: 100%;
}

.entrance-bottom {
  width: 100%;
  margin-top: 20px;
  overflow: hidden;
  margin-bottom: 20px;
  position: relative;
  height: 700px;
}

.entrance-bottom-frame {
  transition: all 0.8s;
  width: 100000000000%;
  /* width: 5000px; */
  /* overflow-x: hidden; */
  margin: 0 auto;
  height: 630px;
  margin-top: 40px;
  position: absolute;
  left: 50%;
  margin-left: -550px;
  font-size: 12px;
  font-family: "微软雅黑", "宋体", "Arial Narrow", Helvetica, sans-serif;
  color: #000;
  line-height: 1.2;
  text-align: left;
}

.entrance-bottom-frame-beijing {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: url("/static/images/yincang.png");
  background-size: cover;
}

.entrance-bottom-frame-line {
  -webkit-filter: grayscale(100%);
  /* CSS3 filter方式，webkit内核方式，firefox外的绝大部分的现代浏览器*/
  -moz-filter: grayscale(100%);
  /* 目前没有实现 */
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  /* CSS3 filter方式，标准写法*/
  filter: gray;
  /* IE 6-9 */
  transition: all 0.8s;
  pointer-events: none;
  cursor: default;
  margin-top: 35px;
  box-shadow: 0 0 15px #c5e2ff;
  width: 1000px;
  height: 570px;
  float: left;
  margin-left: 50px;
  position: relative;
}

.entrance-bottom-frame-line-id {
  font-size: 30px;
  color: white;
  text-align: center;
  line-height: 60px;
  position: absolute;
  left: 50%;
  margin-left: -30px;
  height: 60px;
  width: 60px;
  /* background: url(/static/images/e-id.png); */
  background-image: linear-gradient(45deg, #093976, #1cb5e0);
  border-radius: 50%;
  background-size: cover;
  top: -30px;
}

.entrance-bottom-frame-line-title {
  font-size: 14px;
  width: 900px;
  margin: 70px auto 20px auto;
}

.entrance-bottom-frame-line-title-img {
  height: 100px;
}

.entrance-bottom-frame-line-title-option-img {
  height: 100%;
}

.entrance-bottom-frame-line-title span {
  float: left;
  height: 40px;
  width: 40px;
  text-align: center;
  margin-right: 10px;
  font-size: 24px;
  color: #fff;
  background: url(/static/images/e-id.png);
  background-size: cover;
}

.entrance-bottom-frame-line-button {
  transition: margin 0.8s;
  position: relative;
  cursor: pointer;
  width: 420px;
  height: 70px;
  margin: 10px 20px 0px 45px;
  float: left;
  box-sizing: border-box;
  background: #f1f1f1;
  border-radius: 36px;
  padding: 0 35px;
}

.long {
  height: 54px;
}

.long .entrance-bottom-frame-line-button-id {
  line-height: 54px;
}

.long .entrance-bottom-frame-line-button-frame {
  height: 54px;
}

.short {
  height: 70px;
}

.entrance-bottom-frame-line-button-id {
  width: 30px;
  line-height: 70px;
  display: table-cell;
  font-size: 24px;
}

.entrance-bottom-frame-line-button-frame {
  line-height: 20px;
  width: 335px;
  height: 70px;
  display: table-cell;
  /* font-size: 14px; */
  vertical-align: middle;
}

.entrance-bottom-frame-line-button:hover {
  color: white;
  background: linear-gradient(to right, #ff916a, #ff6a6b);
}

.entrance-bottom-frame-line.active {
  pointer-events: auto;
  height: 630px;
  margin-top: 0;
  -webkit-filter: grayscale(0%);
  /* CSS3 filter方式，webkit内核方式，firefox外的绝大部分的现代浏览器*/
  -moz-filter: grayscale(0%);
  /* 目前没有实现 */
  -ms-filter: grayscale(0%);
  -o-filter: grayscale(0%);
  filter: grayscale(0%);
  /* CSS3 filter方式，标准写法*/
  filter: none;
}

.entrance-bottom-frame-line.active .entrance-bottom-frame-line-button {
  margin-top: 30px;
}

.entrance-bottom-frame-line.active .entrance-bottom-frame-beijing {
  display: none;
}

.entrance-bottom-frame-beijing.none {
  background: #000000;
  opacity: 0.2;
}

.pre_message {
  width: 900px;
  height: 280px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 35px 90px;

  box-sizing: border-box;
  outline: none;
  border: 0;
  white-space: pre-wrap;
  word-break: normal;
  background: url(/static/images/code.png);
  margin: 0 auto;
  font-size: 14px;
}

.pre_message::-webkit-scrollbar {
  display: none;
}

/* CSS Document */
/*Reset*/
* {
  box-sizing: content-box;
}

a:hover,
a:focus {
  text-decoration: none;
}

body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
form,
fieldset,
input,
textarea,
p,
blockquote,
th,
td {
  margin: 0;
  padding: 0;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

body {
  /* max-width: 1920px; */
  -webkit-text-size-adjust: none;
}

fieldset,
img {
  border: 0;
}

img {
  vertical-align: top;
  max-width: 100%;
}

address,
caption,
cite,
code,
dfn,
em,
th,
var {
  font-style: normal;
  font-weight: normal;
}

ol,
ul {
  list-style: none;
}

caption,
th {
  text-align: left;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: normal;
}

q:before,
q:after {
  content: "";
}

abbr,
acronym {
  border: 0;
}

.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}

* html .clearfix {
  zoom: 1;
}

/* IE6 */
*:first-child + html .clearfix {
  zoom: 1;
}

/* IE7 */
.cli {
  clear: both;
  font-size: 0;
  height: 0;
  overflow: hidden;
  display: block;
}

.lclear {
  clear: left;
  font-size: 0;
  height: 0;
  overflow: hidden;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

a {
  color: #333;
  text-decoration: none;
}

.btns {
  position: absolute;
  right: 30px;
  bottom: 30px;
}

.btns div {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #fff;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
  background-color: #091d7c;
  border-color: #091d7c;
  margin: 0 10px;
}

.btns div:hover {
  background: #66b1ff;
  border-color: #66b1ff;
  color: #fff;
}

.btns .back {
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
}

.btns .back:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}

.entrance-bottom-frame-line .btns {
  display: none;
}

.active .btns {
  display: block;
  position: absolute;
  right: 20px;
  top: 20px;
}

.btns .submit {
  display: none;
}

.active_option {
  background: linear-gradient(to right, #ff916a, #ff6a6b);
  /* 标准的语法 */
}
</style>



// WEBPACK FOOTER //
// src/views/outsideranswer/OutsiderAnswer.vue